 import axios from 'axios'

  axios.defaults.baseURL = process.env.API_URL || 'http://127.0.0.1'
  axios.defaults.timeout = 30000
  axios.defaults.headers['Content-Type'] = 'application/json'

  axios.defaults.responseType = 'json'

  export default axios;



// WEBPACK FOOTER //
// ./src/http/config.js